module.exports = __webpack_public_path__ + "static/img/dance-pic.697a7c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dance-pic.png
// module id = tA8H
// module chunks = 9